---
en:
  budget_actions:
    create_custom_budget: Create Custom Budget
    learn_more: How are forecasts calculated?
    update_import: Update Budget Data
  budget_export:
    export_button: Export Budget Data
  budget_grouping:
    display: Display
    view_by: View by
  budget_import:
    description: Export budget data, modify it in Excel, and import the updated XLSX file here. Power plants are in columns, months are in rows. The system will automatically detect the year from row 4.
    invalid_file_type: Only XLSX files are supported
    upload_error: Error importing budget data
    upload_success: Budget data imported successfully
    upload_success_with_details: Successfully imported %{count} budget records for year %{year}
  budget_source:
    actual_budgets: Showing actual budget data
    actual_message: This data reflects real production and revenue from the past.
    actual_title: Viewing Actual Budget Data
    forecasted_budgets: Showing forecasted budget data
    forecasted_message: These are calculated projections based on historical patterns. Create a custom budget to use your own values.
    forecasted_title: Viewing Forecasted Budget Data
    imported_budgets: Showing imported future budget data
    imported_message: You uploaded custom budget data for this year.
    imported_title: Viewing Imported Budget Data
  budgets_for: Budget for
  dialog:
    new_budget_forecast: New budget forecasts
    unavailable_price_areas: "%{price_areas} have already been created. Click 'Production profile' to edit"
  errors:
    messages:
      budget_already_saved: Budget has already been saved!
      no_forcasts_for_this_year: No forcasts for %{year}
      total_percent: total percent must be exactly 100
  profile:
    average: Average
    price_chart: Price chart
    price_profile: Price profile
    production_profile: Production profile
    production_profile_chart: Production profile chart
    revenue_chart: Revenue chart
    revenue_profile: Revenue profile
    save_budget: Save budget
    total: Total
    validations:
      non_negative: Can't be negative
      required: Required
